import { Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { memo } from 'react';

import {
  AnalyticsSidenavItem,
  AnalyticsSidenavItemButton,
} from '../../analyticsSidenav.types';

import styles from './analyticsSidenavTabs.module.scss';

type AnalyticsSidenavTabsProps = {
  items: readonly AnalyticsSidenavItem[];
};

export const AnalyticsSidenavTabs = memo(function AnalyticsSidenavTabs({
  items,
}: AnalyticsSidenavTabsProps): JSX.Element {
  return (
    <div className={styles.tabs} role="tablist">
      {items.map((item) => (
        <button
          key={item.title}
          role="tab"
          aria-selected={item.active}
          {...(item.active && { tabIndex: -1 })}
          className={classNames(styles.tab, {
            [styles.tabActive]: item.active,
          })}
          onClick={(item as AnalyticsSidenavItemButton).options?.onClick}
        >
          <Text.Paragraph as="span" variant="2" color="inherit">
            {item.title}
          </Text.Paragraph>
        </button>
      ))}
    </div>
  );
});
